import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
import HtmlLink from '../../Ui/Common/HtmlLink';
const SlideOneShowOrganization = (props) => {
    const { name, professionalUnitUrlCode } = props;
    if (!name) {
        return null;
    }
    return (_jsx("li", { children: _jsx(HtmlLink, Object.assign({ isNoLinkComponent: professionalUnitUrlCode ? undefined : 'span', target: '_blank', to: `/consultant_unit/${professionalUnitUrlCode}` }, { children: name })) }));
};
SlideOneShowOrganization.propTypes = {
    name: propStr(),
    professionalUnitUrlCode: propStr(),
};
SlideOneShowOrganization.defaultProps = {
    name: '',
    professionalUnitUrlCode: '',
};
export default SlideOneShowOrganization;
